import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  tryToGetMyKnowledge,
  tryToGetProject
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Create a project
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestCreateNewKnowledge = packet => {
  return {
    type: 'REQUEST_CREATE_NEW_KNOWLEDGE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveCreateNewKnowledgeSuccess = data => ({
  type: 'RECEIVE_CREATE_NEW_KNOWLEDGE_SUCCESS',
  data
})

export const receiveCreateNewKnowledgeFail = data => ({
  type: 'RECEIVE_CREATE_NEW_KNOWLEDGE_FAIL',
  data
})

export const tryToCreateNewKnowledge = packet => (dispatch, getState) => {

  dispatch(requestCreateNewKnowledge(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/knowledge/organization/' + packet.scope, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveCreateNewKnowledgeSuccess(json));
      if(packet.origin_project){
        dispatch(tryToGetProject({id: packet.origin_project}));
        dispatch(push('/workbench/' + packet.scope + '/projects/' + packet.origin_project + '/knowledge/' + json.id));
      } else {
        dispatch(push('/workbench/' + json.scope + '/knowledge/' + json.id));
      }
      dispatch(tryToGetMyKnowledge({org_id: json.scope}));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveCreateNewKnowledgeFail({errors:e, lastSubmit: packet}));
    })
}
